import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import { useDispatch } from 'react-redux';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';

export interface Props {
  label?: string;
  className?: string;
}

export const PremiumFolderCreateButton: React.FC<Props> = ({
  label,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showMediaManager = useCallback(
    () =>
      dispatch(
        pushModal(ModalType.CREATE_PREMIUM_FOLDER, {
          wrapInModal: false,
        })
      ),
    [dispatch]
  );
  useEffect(() => {
    if (window.location.search.includes('new_premium_folder')) {
      window.history.replaceState(
        null,
        document.title,
        window.location.pathname
      );
      showMediaManager();
    }
  }, [showMediaManager]);

  return (
    <Button
      className={className}
      view="b16-undisciplined-designers"
      onClick={showMediaManager}
    >
      {label || t('common.addNew')}
    </Button>
  );
};
PremiumFolderCreateButton.displayName = 'PremiumFolderCreateButton';

export default PremiumFolderCreateButton;
